import { graphql } from '@teachino/shared-infrastructure';
import { topicListItemFragment } from '../folders/topic-list-item';

export const createTopicInCourseMutation = graphql(
  `
    mutation CreateTopicInCourse(
      $name: String!
      $courseId: String!
      $goals: String
    ) {
      createTopicInstance(
        createTopicInstanceInput: {
          name: $name
          goals: $goals
          courseId: $courseId
          position: -1
        }
      ) {
        __typename
        topicInstance {
          id
          topic {
            ...TopicListItem
          }
        }
      }
    }
  `,
  [topicListItemFragment],
);
